import { createContext, type MutableRefObject } from 'react';

import { CanvasShape } from './types/canvas-shape.js';

export const CanvasContext = createContext({
  shapeRefs: new Map<string, MutableRefObject<CanvasShape>>(),
});
